import React, { FC } from 'react';
import { ChipProps } from '@mui/material';
import dynamic from 'next/dynamic';

const Chip = dynamic(() => import('@mui/material/Chip'), { ssr: false }); //<- set SSS to false

interface OptionProps extends ChipProps {
  value: string;
}

export const Option: FC<OptionProps> = (props) => {
  return <Chip style={{ marginRight: 4, marginBottom: 4 }} size="small" variant="outlined" {...props} />;
};
